import { ProductsPage } from 'src/pages'

const Products = () => {
  return <ProductsPage />
}

export default Products
